{
  "version": 1,
  "id": "origin-recipe:hedge-binder",
  "originId": "hedge-binder",
  "family": "touched",
  "providerId": "authored-origin-recipe",
  "providerVersion": "1",
  "seed": "origin-hedge-binder-v1",
  "license": "Project-authored deterministic origin content recipe",
  "recipeOrigin": "Agent-executed D02.4 origin writing lane",
  "sources": [
    {
      "document": "VISION.md",
      "section": "Non-negotiables"
    },
    {
      "document": "docs/design.md",
      "section": "Lore accessibility (Waseem, 13 Sep — world bible approved)"
    },
    {
      "document": "docs/world/04-zones.md",
      "section": "Eight starting-background hooks"
    },
    {
      "document": "docs/plan/03-content-plan.md",
      "section": "Origins — exact hooks, bounded continuation"
    },
    {
      "document": "docs/world/09-naming-and-tone.md",
      "section": "People by cultural naming tradition"
    }
  ],
  "capsuleId": "capsule:origin:hedge-binder",
  "capsuleKind": "origin",
  "title": "The Distilled Threshold",
  "bibleHook": {
    "openingGoal": "Clear a mentor's name or, if already dead, secure an honest finding about their work.",
    "complication": "The relevant safe ritual shares reagents with corpse-work; practical knowledge can distinguish the process.",
    "nonCombatLeverage": "Practical ritual chemical formula knowledge distinguishes lawful Kept Warmth and Narrow Threshold from illicit necromantic binding salts.",
    "guardrail": "Shared reagents are not proof of corpse-work. A deceased mentor stays dead after exoneration."
  },
  "sourceBoundRelative": {
    "roleId": "role:hedge-binder:mentor",
    "relationKind": "mentor",
    "preferredPersonId": "person:corren-vel",
    "preferredName": "Corren Vel",
    "culture": "Orsene",
    "identifyingHistory": "Elder hedge binder accused of supplying embalming vitriol to illicit corpse-operators.",
    "deadAlternativeKind": "revised-goal",
    "deadAlternativeSummary": "Secure an honest finding clearing your deceased mentor's workshop records and burial registry from the charge of corpse-work."
  },
  "sourceBoundItems": [
    {
      "id": "item:corren-formula-notebook",
      "name": "Corren's workshop notebook of mineral washes",
      "kind": "tool",
      "provenanceKey": "hedge-workshop:corren-formulas",
      "description": "Hand-stitched paper notebook detailing the proportions of bay salt, alum, and calcined lime used in lawful threshold preservation."
    },
    {
      "id": "item:purified-calcined-lime",
      "name": "Sample jar of purified alkaline wash",
      "kind": "quest-right",
      "provenanceKey": "corren-stock:lawful-wash-sample",
      "description": "A sealed earthenware pot containing non-reactive mineral wash prepared for treating fever sores and cooling dead skin."
    }
  ],
  "personalGoal": {
    "id": "goal:hedge-binder-exoneration",
    "personId": "person:pc",
    "description": "Clear Corren Vel's name before the Reeve by proving his seized reagents were prepared for lawful threshold maintenance, not corpse-binding.",
    "prerequisites": {
      "all": [
        "arrived:silt-stair"
      ],
      "any": [],
      "none": []
    }
  },
  "outcomes": [
    {
      "goalId": "goal:hedge-binder-exoneration",
      "status": "achieved",
      "summary": "You demonstrate the chemical distillation before Melian and the court, securing an official acquittal of sacrilege for Corren Vel.",
      "effects": {
        "add": [
          "corren:exonerated",
          "lawful-binding:defended"
        ],
        "remove": [
          "corren:accused-of-necromancy"
        ]
      }
    },
    {
      "goalId": "goal:hedge-binder-exoneration",
      "status": "compromised",
      "summary": "Corren is cleared of necromancy but his shop stock is forfeited to the municipal apothecary for practicing without an imperial license.",
      "effects": {
        "add": [
          "corren:cleared-unlicensed",
          "workshop-stock:forfeited"
        ],
        "remove": [
          "corren:accused-of-necromancy"
        ]
      }
    },
    {
      "goalId": "goal:hedge-binder-exoneration",
      "status": "failed",
      "summary": "The court declares all hedge binding suspect and orders the workshop burned, branding Corren a condemned corpse-worker.",
      "effects": {
        "add": [
          "corren:condemned",
          "workshop:destroyed"
        ],
        "remove": [
          "corren:accused-of-necromancy"
        ]
      }
    },
    {
      "goalId": "goal:hedge-binder-exoneration",
      "status": "abandoned",
      "summary": "Fearing the Reeve's bailiffs, you pack Corren's notebooks and leave the Silt Stair, letting the false accusations stand.",
      "effects": {
        "add": [
          "exoneration:abandoned-unresolved"
        ],
        "remove": []
      }
    }
  ],
  "questRoles": [
    {
      "id": "role:hedge-binder:mentor",
      "role": "origin-relative",
      "zone": "Z03",
      "preferredPersonId": "person:corren-vel",
      "alternatives": [
        {
          "kind": "revised-goal",
          "goalId": "goal:hedge-binder-honest-finding",
          "summary": "Secure an honest finding clearing your deceased mentor's workshop records and burial registry from the charge of corpse-work.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          }
        },
        {
          "kind": "person",
          "personId": "person:melian-sar",
          "identifyingHistory": "Licensed practitioner at the cold baths who understands lawful rites.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          }
        },
        {
          "kind": "evidence",
          "evidenceId": "evidence:corren-assay",
          "prerequisites": {
            "all": [
              "found:corren-assay"
            ],
            "any": [],
            "none": []
          }
        }
      ]
    }
  ],
  "questNodes": [
    {
      "id": "node:hedge-binder:inspect-seized-jars",
      "label": "Inspect the seized reagent jars at Melian's dispensary",
      "prerequisites": {
        "all": [
          "arrived:silt-stair"
        ],
        "any": [],
        "none": [
          "jars:inspected"
        ]
      },
      "effects": {
        "add": [
          "jars:inspected"
        ],
        "remove": []
      }
    },
    {
      "id": "node:hedge-binder:demonstrate-wash",
      "label": "Demonstrate lawful reagent distillation to the licensed practitioner",
      "prerequisites": {
        "all": [
          "jars:inspected"
        ],
        "any": [
          "melian:distinction-recognized"
        ],
        "none": [
          "corren:demonstrated-innocent"
        ]
      },
      "effects": {
        "add": [
          "corren:demonstrated-innocent",
          "found:corren-assay"
        ],
        "remove": []
      }
    }
  ],
  "dialogueOptions": [
    {
      "id": "opt:hedge-binder:request-inspection",
      "intention": {
        "kind": "ask",
        "label": "Ask Melian Sar to inspect the confiscated jars"
      },
      "text": "The bailiffs seized three jars of mineral salt from Corren Vel's shop and claimed they were bought for the kilns. You are licensed by the court; look at the salt.",
      "disclosure": "essential",
      "firstEncounterSummary": "Ask Melian Sar to inspect your mentor's confiscated reagent jars.",
      "prerequisites": {
        "all": [
          "arrived:silt-stair"
        ],
        "any": [],
        "none": [
          "melian:jars-requested"
        ]
      },
      "effects": {
        "add": [
          "melian:jars-requested",
          "jars:presented-on-bench"
        ],
        "remove": []
      },
      "requiredIncentives": [],
      "requiredProtections": [],
      "socialDifficulty": null
    },
    {
      "id": "opt:hedge-binder:leverage-chemical-assay",
      "intention": {
        "kind": "offer",
        "label": "Demonstrate the alkaline wash distinction"
      },
      "text": "Corren used bay salt and washed chalk to prepare the Narrow Threshold. It stops rot without stiffening muscle. Smell the sulfur in Tavren Noll's kiln jars: that is calcined vitriol and antimony, used to tether nerve tissue. They share raw minerals, but the distillation is completely distinct.",
      "disclosure": "essential",
      "firstEncounterSummary": "Use practical ritual knowledge to prove your mentor's reagents are safe and lawful.",
      "prerequisites": {
        "all": [
          "jars:presented-on-bench"
        ],
        "any": [],
        "none": [
          "melian:distinction-recognized"
        ]
      },
      "effects": {
        "add": [
          "melian:distinction-recognized",
          "leverage:chemical-distinction-proved"
        ],
        "remove": []
      },
      "requiredIncentives": [
        "knowledge:reagent-distillation"
      ],
      "requiredProtections": [],
      "socialDifficulty": 2
    },
    {
      "id": "opt:hedge-binder:warn-false-witch-hunt",
      "intention": {
        "kind": "warn",
        "label": "Warn of indiscriminate persecution against all binders"
      },
      "text": "If you let the Reeve brand every herbal binder as a corpse-worker, the townspeople will tear down your dispensary next when the fever returns.",
      "disclosure": "supporting",
      "firstEncounterSummary": null,
      "prerequisites": {
        "all": [
          "leverage:chemical-distinction-proved"
        ],
        "any": [],
        "none": [
          "melian:committed-to-testify"
        ]
      },
      "effects": {
        "add": [
          "melian:committed-to-testify"
        ],
        "remove": []
      },
      "requiredIncentives": [],
      "requiredProtections": [],
      "socialDifficulty": 3
    },
    {
      "id": "opt:hedge-binder:deep-ritual-origins",
      "intention": {
        "kind": "ask",
        "label": "Ask why lawful rites share ingredients with corpse-work"
      },
      "text": "Why do both lawful preservation and the kiln tethers rely on brine and alum? Did the ancient binders discover corpse-work by accident while trying to comfort the dying?",
      "disclosure": "deep",
      "firstEncounterSummary": null,
      "prerequisites": {
        "all": [
          "melian:committed-to-testify"
        ],
        "any": [],
        "none": [
          "lore:shared-reagent-history"
        ]
      },
      "effects": {
        "add": [
          "lore:shared-reagent-history"
        ],
        "remove": []
      },
      "requiredIncentives": [],
      "requiredProtections": [],
      "socialDifficulty": null
    },
    {
      "id": "opt:hedge-binder:leave-dispensary",
      "intention": {
        "kind": "leave",
        "label": "Step outside into the bath court"
      },
      "text": "I will leave Corren's notebook with you while you prepare the test reagents.",
      "disclosure": "supporting",
      "firstEncounterSummary": null,
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "pc:in-bath-court"
        ],
        "remove": []
      },
      "requiredIncentives": [],
      "requiredProtections": [],
      "socialDifficulty": null
    }
  ],
  "evidence": [
    {
      "id": "evidence:corren-assay",
      "caseId": "case:unburied",
      "kind": "lawful-demonstration",
      "sourceKey": "chemical-demonstration:corren-salts",
      "finding": "Corren Vel's seized jars contain washed chalk and bay salt for fever relief, completely lacking the vitriol required for necromantic tethers.",
      "verified": true,
      "witnessId": null
    },
    {
      "id": "evidence:seizure-inventory",
      "caseId": "case:unburied",
      "kind": "document",
      "sourceKey": "bailiff-inventory:corren-shop",
      "finding": "The bailiff recorded common tanning alum as prohibited necromantic reagent to inflate seizure bounties.",
      "verified": true,
      "witnessId": null
    }
  ],
  "witnessProtections": [
    {
      "id": "protection:corren-vel",
      "witnessId": "person:corren-vel",
      "kind": "public-custody",
      "guarantorId": "institution:reeves-court",
      "commitments": [
        "Suspend sacrilege proceedings during chemical verification",
        "Protect Corren's shop from mob seizure"
      ],
      "secured": true
    }
  ],
  "firstEncounter": {
    "speaker": "Practitioner Melian Sar",
    "location": "Z03 Cold Bath Dispensary",
    "context": "You arrive at Melian's dispensary to clear Corren Vel from the charge of supplying necromancers with binding salts.",
    "initialNpcDialogue": "The bailiffs brought three crates of mineral wash from Corren Vel's workroom. People on the street smell sulfur and call it necromancy. If you cannot prove otherwise, the court will burn his books tomorrow.",
    "progressiveDisclosureReview": {
      "immediateObjective": "Examine the confiscated mineral jars and clear Corren Vel of participating in corpse-work.",
      "nextAction": "Demonstrate the chemical distinction between safe threshold washes and necromantic binding salts to Melian Sar.",
      "whoBenefits": "Your mentor Corren Vel (or his posthumous memory) and ordinary binders who face mob violence.",
      "costOrRisk": "Proving your technical expertise in ritual chemistry invites scrutiny from bailiffs hunting for unlicensed practitioners.",
      "doesDeadPersonReturn": "No. A deceased mentor stays dead after exoneration; clearing their name cleanses their public record, not their breathing."
    }
  },
  "loreAccessibility": {
    "prohibitedJargonChecked": true,
    "intelligentNotGeniusReadingLevel": true,
    "readingLevelNotes": "Focuses on jars, chalk, sulfur, fevers, and bailiffs. Avoids high-fantasy magic explanations."
  },
  "playerFacingWordCount": 332
}
